class Config {
	config: any = {};
	constructor () {
		try {
			const cnf: any = document.getElementById('config-server-data')?.innerText;
			this.config = JSON.parse(cnf);
		} catch (error) {
			
		}
	}

	get domain () {
		return this.config.DOMAIN_BASE || process.env.VUE_APP_DOMAIN_BASE;
	}

	get googleMapsKey () {
		return this.config.GOOGLE_MAPS_KEY || process.env.VUE_APP_GOOGLE_MAPS_KEY;
	}

	get api () {
		return this.config.API_BASE || process.env.VUE_APP_API_BASE;
	}

	get webapi () {
		return this.api.replace('technician.', "web")
	}

	get pulsImagesBucket () {
		return this.config.PULS_IMAGES_BUCKET || process.env.VUE_APP_PULS_IMAGES_BUCKET;
	}

	get cxDeviceAttrImagesBucket () { 
		return this.config.CX_DEVICE_ATTR_IMG_BUCKET || process.env.VUE_APP_DEVICE_ATTR_IMAGES_BUCKET;
	}

	get checklistImagesBucket () {
		return this.config.CHECKLIST_IMAGES_BUCKET || process.env.VUE_APP_CHECKLIST_IMAGES_BUCKET
	}

	get imageProxy () {
		return `${this.api}/img-proxy/s3/?img=`
	}

	get noLoginApp () {
		return this.config.NO_LOGIN_APP
	}
}

export default new Config();
